export default (UserInput,Solution) => {
  UserInput = JSON.parse(UserInput)
  Solution = JSON.parse(Solution)

  //format
  // codes: {
  //   block: [[], []],
  //   range: [[], []],
  //   single: [],
  // },
  // location: "",
  // bonus: [],

  var dynamicFun=[]
  dynamicFun['checker']=function checker(frage,antwort,tolerance,isLocation,isRange){//(soll,antwort,tolerance)
    let correct = 0;
    let solved = false;

    // console.log("solution")
    // console.log(frage)
    // console.log("antwort")
    // console.log(antwort)

    if(isRange){
      if(frage[0] <= parseInt(antwort[0]) && frage[1] >= parseInt(antwort[0])){
        correct++
        frage=[]//skip later for loop
      }
    }

    // if(isLocation && !Array.isArray(frage)){
    //   let helper = [frage]
    //   frage = helper
    // }

    var stars=0

    for (var i = 0; i < frage.length; i++) {//Antwort muss Array sein
      if(Array.isArray(frage[i]) && !isLocation){//Antwort ist wieder ein Array, Stern beachten
        //Range gibt es nicht mehr!
        for (var a = 0; a < frage[i].length; a++) {
          if(!antwort[i][a]) antwort[i][a]=""
          if(frage[i][a]=='*'){
            if(antwort[i][a]=='' || antwort[i][a]==' '){
              stars++
              // correct++            
            }
          }else{
            if(frage[i][a].toString().toUpperCase() == antwort[i][a].toString().toUpperCase()){
              correct++
            }
          }
        }
      }else{//single und range    
        if(!Array.isArray(antwort)){
          if(!antwort) antwort=""
          if (frage[i].toString().toUpperCase() == antwort.toString().toUpperCase()) correct++
        }else{//antwort ist array
          if(!antwort[i]) antwort[i]=""
          if (frage[i].toString().toUpperCase() == antwort[i].toString().toUpperCase()) correct++
        }
      }
    }

    // console.log(tolerance)
    if(tolerance){
      if(Array.isArray(frage[0]) && !isLocation){//isBlock
        // console.log(correct+">="+ frage[0].length+"-"+tolerance+"-"+stars)
        if (correct >= frage[0].length-tolerance-stars){
          solved = true
        }
      }else{
        // console.log(correct+">="+ frage.length+"-"+tolerance+"-"+stars)
        if (correct >= frage.length-tolerance-stars){
          solved = true
        }
      }
    }else{
        if (correct >= frage.length) solved = true
    }
  
    return solved  
  }

  dynamicFun['checkMAZ']=function checkMAZ(entries,antwort,tolerance){
    let correct = 0;
    let solved = false;

    entries = entries[0]
    antwort = antwort[0]

    console.log("solution")
    console.log(entries)
    console.log("antwort")
    console.log(antwort)
  
    for (var i = 0; i < entries.length; i++) {
      for(var a = 0; a < entries.length; a++){
        if(!antwort[a] || antwort[a]==' ') antwort[a]="*"
        console.log(entries[i].toString().toUpperCase()+"=="+antwort[a].toString().toUpperCase())
        // console.log("next")
        if(entries[i].toString().toUpperCase() == antwort[a].toString().toUpperCase()){
          // console.log("correct")
          antwort.splice(a,1);
          // console.log(antwort)
          correct ++
          break
        }
      }
    }
  
    if(tolerance){
      if (correct >= entries.length-tolerance){
        solved = true
      }
    }else{
      if (correct >= entries.length) solved = true
    }

    // for(a = 0; a < antwort.length; a++){
    //   if(antwort[a]=='*') antwort[a]=""
    // }
  
    return solved  
  }

  function solveLocation(frage,antwort){
    let correct = 0;
    let solved = false;
    if(!Array.isArray(frage)){
      let helper = [frage]
      frage = helper
    }

    for (var i = 0; i < frage.length; i++) {//Antwort muss Array sein
      if(!antwort) antwort=""   
      antwort = antwort.replace(/\s+/g, '');   
      if (frage[i].toString().toUpperCase() == antwort.toString().toUpperCase()) correct++
    
    }

    if (correct >= 1) solved = true

    return solved
  }

  // console.log(obj)
  // var aufgabenID = obj.aufgabenID
  var codes = UserInput.codes
  var bonus = UserInput.bonus
  var location = UserInput.location

  var bonusSolved=false

  if(UserInput.codes.length==0) codes=0
  if(UserInput.bonus.length==0) bonus=0
  
  var solvedArray=[]

  const aufgabe = Solution
  // console.log("AUFGABE:")
  // console.log(aufgabe)
  if (!aufgabe) return false;

  //checker(soll,antwort,tolerance)
try {
  // console.log("INSIDE")
  var methodName='checker'
  let name = UserInput.name.split("#")[0]
  if(name=="GRD" || name=="MAZ" || name=="CUB"){
    methodName='checkMAZ'
  }
  // console.log("methodName: "+methodName)
  //                                                              soll,              antwort,     tolerance,   islocation, range
  if(aufgabe.codes.block) solvedArray.push(dynamicFun[methodName](aufgabe.codes.block,codes.block,aufgabe.Block_tolerance,false))
  // console.log(solvedArray)
  if(aufgabe.codes.range) solvedArray.push(dynamicFun['checker'](aufgabe.codes.range,codes.range,0,false,true))
  if(aufgabe.codes.single) solvedArray.push(dynamicFun['checker'](aufgabe.codes.single,codes.single,aufgabe.Single_tolerance,false))
  // console.log("jetzt kommt location")
  // if(aufgabe.location) solvedArray.push(dynamicFun['checker'](aufgabe.location,location,0,true))
  if(aufgabe.location){
    solvedArray.push(solveLocation(aufgabe.location,location))
  }
  console.log(solvedArray)
  if(aufgabe.bonus){
    // console.log("Aufgabe has bonus_______________")
    if(dynamicFun['checker'](aufgabe.bonus,bonus,0,false)){
      // console.log('bonus richtig!')
      bonusSolved=true
    }
    // console.log("bonus solved correctly: "+bonusSolved)
  }
  

  // console.log("_____________________ unten ____________________")
  // console.log(solvedArray)
    
  var solvedAll=false
  var solvedCounter=0
  //console.log(solvedArray)
  for(var s of solvedArray){
    //console.log(s)
    if(s) solvedCounter++
  }


  if(solvedCounter>=solvedArray.length && solvedCounter>0) solvedAll=true
  
  return{
    bonus:bonusSolved,
    solved:solvedAll
  }
} catch (error) {
  console.log(error)
  return{
    bonus:false,
    solved:false
  }
}
}